/**
 * Books layout guard — Layer 3 of the module gate (ADR-0046).
 *
 * Books/accounting statements are a 1.0-withheld module (Tally XML export is the
 * 1.0 answer; Books returns in 1.2). This layout route redirects a typed
 * `/books` URL and any nested child to `/` unless the workspace is entitled to
 * `books`, which no 1.0 plan grants. Renders only an `<Outlet/>`.
 * @see docs/adr/0046-withheld-1.0-modules.md
 */
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireModule } from "../../../../features/workspace/index.ts";

export const Route = createFileRoute("/(workspace)/compliance/books")({
  beforeLoad: requireModule("books"),
  component: Outlet,
});
